<template>
    <!-- <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <div class="card-tools">
                        <button ype="button" class="btn btn-sm btn-success" title="Cập nhật quyền menu" @click="onSubmit()"
                            >
                            Cập nhật quyền menu
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th>Tên menu
                                        <div class="float-right">Quyền cập nhật</div>
                                        <div class="float-right mr-3">Quyền xem</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-for="item in items" :key="item.id">
                                <tr v-if="item.children.length == 0">
                                    <td>{{ item.ten }}
                                        <div class="float-right">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    :id="'item' + item.id" v-model="item.quyenCapNhat"
                                                    v-on:click="onChangeRole(item)">
                                                <label class="custom-control-label" :for="'item' + item.id"
                                                    title="Quyền cập nhật"></label>
                                            </div>
                                        </div>
                                        <div class="float-right mr-5">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    :id="'item2' + item.id" v-model="item.quyenXem"
                                                    v-on:click="onChangeRole(item)">
                                                <label class="custom-control-label" :for="'item2' + item.id"
                                                    title="Quyền xem"></label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="item.children.length != 0" data-widget="expandable-table"
                                    aria-expanded="true">
                                    <td>
                                        <i class="expandable-table-caret fas fa-caret-right fa-fw"></i>{{ item.ten }}
                                        <div class="float-right">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    :id="'item' + item.id" v-model="item.quyenCapNhat"
                                                    v-on:click="onChangeRole(item)">
                                                <label class="custom-control-label" :for="'item' + item.id"
                                                    title="Quyền cập nhật"></label>
                                            </div>
                                        </div>
                                        <div class="float-right mr-5">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    :id="'item2' + item.id" v-model="item.quyenXem"
                                                    v-on:click="onChangeRole(item)">
                                                <label class="custom-control-label" :for="'item2' + item.id"
                                                    title="Quyền xem"></label>
                                            </div>
                                        </div>
                                    </td>


                                </tr>
                                <tr class="expandable-body" v-if="item.children.length != 0">
                                    <td>
                                        <div class="p-0">
                                            <table class="table table-hover">
                                                <tbody v-for="itemChildren in item.children" :key="itemChildren.id">
                                                    <tr>
                                                        <td>{{ itemChildren.ten }}
                                                            <div class="float-right">
                                                                <div class="custom-control custom-switch">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'item' + itemChildren.id"
                                                                        v-model="itemChildren.quyenCapNhat"
                                                                        v-on:click="onChangeRole(itemChildren)">
                                                                    <label class="custom-control-label"
                                                                        :for="'item' + itemChildren.id"
                                                                        title="Quyền cập nhật"></label>
                                                                </div>
                                                            </div>
                                                            <div class="float-right mr-5">
                                                                <div class="custom-control custom-switch">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'item2' + itemChildren.id"
                                                                        v-model="itemChildren.quyenXem"
                                                                        v-on:click="onChangeRole(itemChildren)">
                                                                    <label class="custom-control-label"
                                                                        :for="'item2' + itemChildren.id"
                                                                        title="Quyền xem"></label>
                                                                </div>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <!-- <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>

            <!-- <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">Chi tiết</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="modelRec">
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <p class="text-sm">ID:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.id }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tên
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ten }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Menu code
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.menuCode }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Cấp độ
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.capDo }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Đường dẫn
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.duongDan }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Icon
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.icon }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Menu cha
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenMenuCha }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">STT
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Hiển thị trên cổng:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                                            }}&nbsp;</b>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div> -->
        </div>
    </section>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
// import TheInputText from '@/components/shareComponents/TheInputText.vue';
// import TheSelect from '@/components/shareComponents/TheSelect.vue';

// import { menuModel } from '@/models/menu/menu.model'

export default {
    name: "TheMenuDanhSach",
    components: {
        paginate: Paginate,
        loading: Loading,
        // TheInputText,
        // TheSelect,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            // modelRec: menuModel.newModel(),
            // model: menuModel.newFEModel(),

            list_MenuRoles: [],
            listSend_MenuRoles: [],

            paramRoleId: "",

            category_MENUCHA: [],

            sType_List: 1,

            tempKey: common.randomString(10)
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('menuDanhSach', ['getRolesMenuTree', 'addRolesMenuTree']),
        async setup() {
            let header = 'Danh sách quyền menu'
            this.setupHeader({ header })
        },

        async initialize() {
        },

        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },
        async onChangeRole(itemValue) {
            let index = this.listSend_MenuRoles.findIndex(item => item.id === itemValue.id);
            if (index == -1) {
                //Không tìm thấy
                this.listSend_MenuRoles.push(itemValue)
            }
            else {
                //Tìm thấy
                this.listSend_MenuRoles[index] = itemValue;
            }
        },

        async getData() {
            this.isBusy = true
            let params = {
                roleId: this.paramRoleId,
            }
            await this.getRolesMenuTree({ params: params }).then(res => {
                // List data
                if (res) {
                    this.items = res
                    this.items.forEach(element => {
                        this.list_MenuRoles.push(
                            {
                                id: element.id,
                                ten: element.ten,
                                quyenXem: element.quyenXem,
                                quyenCapNhat: element.quyenCapNhat
                            }
                        )
                        if (element.children.length > 0) {
                            element.children.forEach(childElement => {
                                this.list_MenuRoles.push(
                                    {
                                        id: childElement.id,
                                        ten: childElement.ten,
                                        quyenXem: childElement.quyenXem,
                                        quyenCapNhat: childElement.quyenCapNhat
                                    }
                                )
                            })
                        }
                    });
                }


            });
            this.isBusy = false;
        },

        async onSubmit() {
            let menuInfo = []
            this.listSend_MenuRoles.forEach(element => {
                menuInfo.push(
                    {
                        id: element.id,
                        quyenXem: element.quyenXem,
                        quyenCapNhat: element.quyenCapNhat,
                    }
                )
            })
            if (menuInfo.length > 0) {
                let jsonSend = {
                    roleId: this.paramRoleId,
                    menuInfo: menuInfo
                }
                await this.addRolesMenuTree({ params: jsonSend }).then(resp => {
                    if(resp){
                        this.getData()
                    }
                });
            }
            else{
                this.warning("Không có thông tin được thay đổi!")
            }


        }
    },

    async mounted() {
        this.paramRoleId = this.$route.params.id;
        await this.initialize()
        await this.setup()
        await this.getData()
    }


}
</script>
<style></style>